import DeliveryImage from '@/assets/images/delivery-image.png';

const AddressIllustration = () => (
    <div className="w-full relative md-min:mb-[7rem] xl-min:mb-[0rem]">
        <div className="illusTextContainer desktop-min:illusTextContainer__desktop__min">
            <div className="illus-text">
                <p className="font-atkinsonBold italic text-[1.625rem] sm-max:text-[1.125rem]">No More Dashes to the Pharmacy!</p>
                <p className="text-[1.625rem] sm-max:text-[1.125rem]">
                    With MedBox, your refills arrive at your doorstep before you run out.
                </p>
            </div>
        </div>
        <img
            src={DeliveryImage}
            alt="About you image"
            className="delivery  w-[10rem] h-auto hidden desktop-min:block desktop-min:absolute desktop-min:-left-[5rem] desktop-min:top-9"
        />
    </div>
);


export default AddressIllustration;